
export default {
  props: {
    categories: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    filterOpen: false,
    filters: [],
  }),
  methods: {
    submit() {
      this.$emit('filters-changed', this.filters);
      this.filterOpen = false;
    },
    toggleFilter(slug) {
      if (this.filters.includes(slug)) {
        this.filters = this.filters.filter(filter => filter !== slug);
      } else {
        this.filters.push(slug);
      }
    },
  },
};
